import * as Yup from 'yup';
import { Param } from '../../../../../../shared/types/param';

export const initialValues: Param = {
    code: '',
    class: '',
    name: '',
    extra: '',
};

export const validationSchema = () =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        extra: Yup.string().required('La descripción es obligatoria'),
    });
